// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__cZBos","active":"Categories_active__Jk2cg"};